export default {
    ABOUT: '/about',
    BOOKING: '/booking',
    CATEGORY: '/category/:categoryId',
    CONTACT: '/contact',
    EVENT: '/gallery/:galleryId',
    HOME: '/'
};
